const DEFAULT_PRICING_PERIOD = 'annual';
const PRICING_PERIOD_EVENT = 'wombat:pricing-period-change';

/**
 * Normalize the requested pricing period.
 *
 * @param {string} period Raw pricing period.
 * @return {string} Normalized pricing period.
 */
const normalizePricingPeriod = ( period ) => period === 'monthly' ? 'monthly' : DEFAULT_PRICING_PERIOD;

/**
 * Read the current global pricing period.
 *
 * @return {string} Current pricing period.
 */
const getPricingPeriod = () => normalizePricingPeriod( window.wombat?.pricingPeriod );

/**
 * Persist the pricing period globally and notify listeners.
 *
 * @param {string} period Requested pricing period.
 * @return {string} Persisted pricing period.
 */
const setPricingPeriod = ( period ) => {

	const nextPeriod = normalizePricingPeriod( period );
	const previousPeriod = getPricingPeriod();

	window.wombat = window.wombat || {};
	window.wombat.pricingPeriod = nextPeriod;

	if ( previousPeriod !== nextPeriod ) {

		window.dispatchEvent( new CustomEvent( PRICING_PERIOD_EVENT, {
			detail: {
				period: nextPeriod,
			},
		} ) );

	}

	return nextPeriod;

};

/**
 * Subscribe to global pricing period changes.
 *
 * @param {Function} callback Change callback.
 * @return {void}
 */
const subscribeToPricingPeriodChange = ( callback ) => {

	window.addEventListener( PRICING_PERIOD_EVENT, ( event ) => {

		callback( normalizePricingPeriod( event.detail?.period ) );

	} );

};

/**
 * Update the switcher UI for the active pricing period.
 *
 * @param {HTMLElement[]} buttons Switcher buttons.
 * @param {string} period Active pricing period.
 * @return {void}
 */
const updateButtonsState = ( buttons, period ) => {

	buttons.forEach( ( button ) => {

		const isActive = button.dataset.pricingPeriod === period;

		button.classList.toggle( 'is-active', isActive );
		button.setAttribute( 'aria-pressed', isActive ? 'true' : 'false' );

	} );

};

document.querySelectorAll( '.b-pricing-switcher' ).forEach( ( block ) => {

	if ( block.dataset.pricingSwitcherReady === 'true' ) {

		return;

	}

	const buttons = Array.from( block.querySelectorAll( '[data-pricing-period]' ) );
	if ( ! buttons.length ) {

		return;

	}

	const defaultPeriod = normalizePricingPeriod( block.dataset.pricingPeriodDefault );
	const currentPeriod = window.wombat?.pricingPeriod ? getPricingPeriod() : setPricingPeriod( defaultPeriod );

	updateButtonsState( buttons, currentPeriod );

	buttons.forEach( ( button ) => {

		button.addEventListener( 'click', () => {

			setPricingPeriod( button.dataset.pricingPeriod );

		} );

	} );

	subscribeToPricingPeriodChange( ( period ) => {

		updateButtonsState( buttons, period );

	} );

	block.dataset.pricingSwitcherReady = 'true';

} );
